export default {
  setBookingDetails(state, data) {
    state.bookingDetails = {
      ...state.bookingDetails,
      ...data
    }
  },
  setHotelDetails(state, { hotel, benefits, coBrandImage }) {
    state.hotelDetails = {
      ...state.hotelDetails,
      hotel,
      benefits,
      coBrandImage
    }
  },
  fetchingBookingInfo(state) {
    state.bookingDetails.loading = true
  },
  fetchedBookingInfo(state) {
    state.bookingDetails.loading = false
  },
  fetchingHotelInfo(state) {
    state.hotelDetails.loading = true
  },
  fetchedHotelInfo(state) {
    state.hotelDetails.loading = false
  }
}
